import { render } from "./BatteryTestReportContent.vue?vue&type=template&id=7618a5c3&scoped=true"
import script from "./BatteryTestReportContent.vue?vue&type=script&lang=js"
export * from "./BatteryTestReportContent.vue?vue&type=script&lang=js"

import "./BatteryTestReportContent.vue?vue&type=style&index=0&id=7618a5c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7618a5c3"]])

export default __exports__